// oxlint-disable no-unsafe-optional-chaining
import { useEffect, useState } from "react";
import DashboardLayoutMain from "../../../layout/dashboard/DashboardLayoutMain";
import {
  RazorCheckBox,
  RazorInputField,
} from "../../../components/razor-reuse";
import { useDispatch, useSelector } from "react-redux";
import {
  createExportTemplate,
  getExportTemplateField,
} from "../../../redux/export";
import RootState from "../../../redux/type";
import { useNavigate } from "react-router-dom";
import { ALL_ROUTES } from "../../../routes/AllRoutes";

interface formProp {
  name: string;
  type: string;
  fields: string[];
}

export default function CreateTemplate() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const exportType = localStorage.getItem("exportType") || "user";
  const { template_fields, loading_fields, fetching } = useSelector(
    (state: RootState) => state?.exports
  );

  const [form, setForm] = useState<formProp>({
    name: "",
    type: exportType,
    fields: [],
  });

  const handleChange = (e: any) => {
    e?.preventDefault();
    const { name, value } = e?.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    dispatch(getExportTemplateField({ report_type: exportType }) as any);
  }, [form.type]);

  const handleAddToList = (param: string) => {
    // let newList;
    if (form?.fields?.includes(param)) {
      const newList = form?.fields?.filter((chi: string) => chi !== param);
      setForm((prev) => {
        return { ...prev, fields: newList };
      });
    } else {
      const newList = [...form?.fields, param];
      setForm((prev) => {
        return { ...prev, fields: newList };
      });
    }
  };

  const handleSubmit = async () => {
    const data = await dispatch(createExportTemplate(form) as any);
    if (data?.payload?.data?.status) {
      setForm({
        name: "",
        type: exportType,
        fields: [],
      });
      navigate(ALL_ROUTES?.DASHBOARD_EXPORT);
    }
  };

  return (
    <DashboardLayoutMain loading={loading_fields} title="Create Export" back>
      <main className="mt-[20px] mx-[2rem]">
        <p className="capitalize font-semibold text-[18px]">
          {exportType} Export
        </p>
        <section className="bg-white rounded-[8px] mt-[20px] px-[30px] py-[25px] max-w-[1080px]">
          <RazorInputField
            color="black-light"
            type="text"
            label="Template Name"
            name="name"
            value={form.name}
            onChange={handleChange}
            placeholder="Enter template name"
          />

          <div className="grid grid-cols-3 gap-[30px] py-[30px]">
            {template_fields?.fields?.map((item: string, ids: number) => (
              <div
                key={ids}
                className={`inline-flex items-center space-x-[10px] border-[1.5px] p-[10px] rounded-[8px] cursor-pointer relative ${
                  form?.fields?.includes(item) ? "border-pry" : ""
                }`}
                onClick={() => {
                  handleAddToList(item);
                }}
              >
                <div className="inset-0 absolute z-[10]"></div>
                <RazorCheckBox
                  checked={form?.fields?.includes(item)}
                  onChange={() => {}}
                  id={`${ids} inapp` as any}
                  key={`${ids} inapp` as any}
                  color="black-light"
                />
                <p className="text-[14px] text-[#1E1E1E] font-medium uppercase">
                  {item?.replace(/_/g, " ")}
                </p>
              </div>
            ))}
          </div>

          <RazorInputField
            color={`black-light`}
            value="Create A Template"
            type="submit"
            className="btn max-w-80"
            onSubmit={handleSubmit}
            loading={fetching}
            disabled={
              form.name?.trim() === "" || form.fields.length === 0 || fetching
            }
          />
        </section>
      </main>
    </DashboardLayoutMain>
  );
}
